import React from 'react';
import InputBar from './InputBar';
import ImagePreview from './ImagePreview';

const ChatInput = ({ 
  message, 
  onMessageChange, 
  onKeyDown, 
  onSend, 
  selectedImages, 
  onImageSelect, 
  onImageRemove,
  imageError,
  onClearImageError,
  disabled,
  placeholder = 'Message Doc...',
  showImageUpload = true,
  isSending = false,
  isResponseGenerating = false,
}) => {
  return (
    <footer className="chat-input-container">
      <div className="input-wrapper">
        {/* Show image preview and validation error messages */}
        {showImageUpload && (
          <ImagePreview
            images={selectedImages}
            onRemove={onImageRemove}
            error={imageError}
            onClearError={onClearImageError}
          />
        )}
        <InputBar
          value={message}
          onChange={onMessageChange}
          onKeyDown={onKeyDown}
          onSend={onSend}
          onFileSelect={onImageSelect}
          disabled={disabled}
          placeholder={placeholder}
          showFileUpload={showImageUpload}
          isSending={isSending}
          isResponseGenerating={isResponseGenerating}
        />
      </div>
    </footer>
  );
};

export default ChatInput;
